// @ts-strict-ignore
import { AppMetaData, Language } from 'mytours-read-common'
import { generateImageUrl } from 'common_lib/utils'
import { ImageSizePreset } from 'common_lib/types'
import strings from '../../../strings'
import { defineUserMobileDeviceOS } from '../../common/functions'
import { Button } from '@mytours/components'

export function AppBannerContent({
	close,
	visible,
	appMetaData,
	language,
}: {
	close: () => void
	visible: boolean
	appMetaData: AppMetaData
	language: Language
}) {
	const { icon_media_item, app_name, default_name, primary_language } = appMetaData
	const lang = language?.code || primary_language
	const name = (app_name ? app_name[lang] : undefined) || default_name
	const icon = icon_media_item && generateImageUrl(icon_media_item.file, { imageSizePreset: ImageSizePreset.Grid })
	const backgroundImage = `url(${icon || '/android-chrome-192x192.png'})`
	const href = `https://${appMetaData.project_id}.stqry.link${window.location.pathname}`
	return (
		<div className={`app-banner__content ${visible ? 'app-banner__content--visible' : 'app-banner__content--hidden'}`}>
			<div className="app-banner__content__container">
				<div className="app-banner__content__close-wrapper">
					<Button
						variant="clear"
						aria-label="close"
						className="app-banner__content__close-button"
						type="button"
						onClick={close}
					>
						&times;
					</Button>
				</div>
				<div className="app-banner__content__icon" style={{ backgroundImage }} />
				<div className="app-banner__content__info">
					<div className="app-banner__content__app-name">{name}</div>
					<div className="app-banner__content__store-label">
						{defineUserMobileDeviceOS() === 'Android' ? strings.view_in_android_app : strings.view_in_ios_app}
					</div>
				</div>
				<div className="app-banner__content__action-wrapper">
					<a className="app-banner__content__store-link" href={href} rel="noopener">
						<span className="app-banner__content__view-button">{strings.view}</span>
					</a>
				</div>
			</div>
		</div>
	)
}
